import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import {
  CollectionIcon,
  UserGroupIcon,
  IdentificationIcon,
  DocumentIcon,
  DocumentTextIcon,
} from "@heroicons/react/outline";
import SideFooter from "../../components/sidebar/SideFooter";
import { useAuth } from "../../context/AuthContext";
import SidebarWithHeader from "../../components/Layouts/SidebarWithHaeder";
import AppLogo from "../../components/AppLogo";

function SupervisorDashboard() {
  const [langModal, setLangModal] = useState(false);
  const userContext = useAuth();
  const LocalNavBasePath = "page.supervisor.nav";
  const { t, i18n } = useTranslation("", {
    keyPrefix: LocalNavBasePath,
  });
  const navigation: any = [
    {
      name: t(`reciters`),
      href: "/supervisor/dashboard/room/",
      icon: UserGroupIcon,
      separate: "bottom",
    },
    {
      name: t("khetma"),
      href: "/supervisor/dashboard/khetma",
      icon: DocumentTextIcon,
      separate: "bottom",
    },
    {
      name: t(`sessions`),
      href: "/supervisor/dashboard/sessions",
      icon: CollectionIcon,
      separate: "bottom",
    },
    {
      name: t(`requests`),
      icon: DocumentIcon,
      separate: "bottom",
      children: [
        {
          name: t(`recitersRequests`),
          href: "/supervisor/dashboard/requests?tab=0",
        },
        {
          name: t(`readersRequests`),
          href: "/supervisor/dashboard/requests?tab=1",
        },
      ],
    },
    {
      name: t(`personalInfo`),
      icon: IdentificationIcon,
      href: "/supervisor/dashboard/personal-info",
    },
  ];

  const userImg = userContext?.currentUser?.profile_picture_url;

  return (
    <div className="">
      <div className="">
        <SidebarWithHeader
          langModal={langModal}
          setLangModal={setLangModal}
          img={userImg}
          navigation={navigation}
          showNotificationIcon={true}
          sideHeader={
            <div className="w-full px-2 pt-5 pb-4">
              <AppLogo />
            </div>
          }
          sideFooter={
            <SideFooter langModal={langModal} setLangModal={setLangModal} />
          }
        ></SidebarWithHeader>
      </div>
    </div>
  );
}
export default SupervisorDashboard;
